import { useEffect } from 'react';
import { log } from 'log';
import { pick } from 'ramda';
import { useDispatch } from 'react-redux';
import { get } from 'js/utils/fetch.util';
import { useAppSelector, useSportsbookSelector } from 'js/store/hooks';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';

import * as actions from '../store/actions';
import { useGetInitParams } from './useGetInitParams';

export const useSportsbookInit = () => {
    const dispatch = useDispatch();
    const initParams = useGetInitParams();
    const getCMSResourceURL = useGetCMSResourceURL();
    const {
        requestStamp,
        sportsbookRootURL,
        isChangeLangInProgress
    } = useAppSelector(pick([
        'requestStamp',
        'sportsbookRootURL',
        'isChangeLangInProgress'
    ]));
    const {
        isAppInitError,
        isAppInitialized,
        isAppInitializing,
        isIntegrationScriptFetched,
        isIntegrationScriptFetching
    } = useSportsbookSelector(pick([
        'isAppInitError',
        'isAppInitialized',
        'isAppInitializing',
        'isIntegrationScriptFetched',
        'isIntegrationScriptFetching'
    ]));

    useEffect(() => {
        if (isIntegrationScriptFetched && !sportsbookRootURL) {
            log('error', '[SPORTSBOOK | Portal] sportsbook root URL is not configured');

            return;
        }

        if (!isIntegrationScriptFetched || isIntegrationScriptFetching
            || isAppInitialized || isAppInitializing || isAppInitError || isChangeLangInProgress) {
            return;
        }

        (async () => {
            try {
                log('log', '[SPORTSBOOK | Portal] app inited with params', { ...initParams });
                dispatch(actions.setAppInitializing());

                if (!window.Sportsbook.initializationPromise) {
                    const configurationURL = getCMSResourceURL('/sportsbookCustomization', { t: requestStamp });
                    const postInitURL = getCMSResourceURL('/sportsbookPostInitConf', { t: requestStamp });

                    window.Sportsbook.init({
                        ...initParams,
                        configuration: get(configurationURL),
                        postInitConfig: get(postInitURL)
                    });
                }

                await window.Sportsbook.initializationPromise;

                dispatch(actions.setAppInitialized(true));
            } catch (error) {
                log('log', '[SPORTSBOOK | Portal] Sportsbook init error', error);

                dispatch(actions.setAppInitError());
            }
        })();
    }, [
        dispatch,
        initParams,
        requestStamp,
        isAppInitError,
        isAppInitialized,
        sportsbookRootURL,
        getCMSResourceURL,
        isAppInitializing,
        isChangeLangInProgress,
        isIntegrationScriptFetched,
        isIntegrationScriptFetching
    ]);
};
